import { IconType } from "../icon-props";

const ArrowDown: IconType = (
        <>
            <path d="M12.0002 13.1717L16.9502 8.22168L18.3642 9.63568L12.0002 15.9997L5.63623 9.63568L7.05023 8.22168L12.0002 13.1717Z"/>
        </>
    );

export default ArrowDown;